export const GET_MODEL_VERSION_BY_PROJECT_ID_REQUEST =
  "GET_MODEL_VERSION_BY_PROJECT_ID_REQUEST";
export const GET_MODEL_VERSION_BY_PROJECT_ID_SUCCESS =
  "GET_MODEL_VERSION_BY_PROJECT_ID_SUCCESS";
export const GET_MODEL_VERSION_BY_PROJECT_ID_FAILURE =
  "GET_MODEL_VERSION_BY_PROJECT_ID_FAILURE";
